import NpsDefault from "../default/NpsDefault";

export default class NpsColor extends NpsDefault
{ }